/**
 * Navbar Component
 *
 * Shared navigation bar with logo and login dropdown.
 */

import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown, faHospitalUser, faUserMd, faTableColumns } from '@fortawesome/free-solid-svg-icons';
import { Link, useLocation } from 'react-router-dom';
import { ThemeToggle } from '../ThemeToggle';

// Register icons for this component
library.add(faChevronDown, faHospitalUser, faUserMd, faTableColumns);

export function Navbar() {
  const location = useLocation();
  const showCTA = location.pathname === '/';

  return (
    <header className="sticky top-0 z-50 w-full border-b border-border/40 bg-background/95 backdrop-blur supports-[backdrop-filter]:bg-background/60">
      <nav aria-label="Principal" className="container flex h-14 items-center justify-between gap-2 sm:gap-4">
        <Link to="/" className="flex items-center gap-2 shrink-0 transition-opacity hover:opacity-80">
          <div className="relative h-7 w-7 overflow-hidden rounded-full">
            <img
              src="/images/logo.round.svg"
              alt="Logo Examfy - Plataforma Médica para Gestão de Exames"
              className="object-cover w-full h-full"
            />
          </div>
          <span className="font-heading font-bold text-xl hidden sm:inline-block">Examfy</span>
        </Link>

        <div className="flex items-center gap-2 sm:gap-4">
          <ThemeToggle />
          {/* Dropdown for Login */}
          <div className="relative group">
            <button className="inline-flex items-center justify-center rounded-md text-xs sm:text-sm leading-tight font-medium transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring bg-primary text-primary-foreground hover:bg-primary/90 h-auto min-h-8 sm:min-h-9 px-3 sm:px-4 py-1.5 text-center">
              <span className="sm:hidden">Acessar</span>
              <span className="hidden sm:inline">Acessar a Plataforma</span>
              <FontAwesomeIcon icon={faChevronDown} className="ml-1.5 sm:ml-2 text-[10px] sm:text-xs" />
            </button>
            {/* Dropdown menu */}
            <div className="absolute left-1/2 -translate-x-1/2 sm:left-auto sm:translate-x-0 sm:right-0 top-full mt-2 w-max max-w-[calc(100vw-2rem)] sm:max-w-[18rem] rounded-xl border bg-popover p-2 text-popover-foreground shadow-xl opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-200 origin-top-right">
              <div className="px-2 py-1.5">
                <a
                  href="/patient"
                  className="flex items-center rounded-md px-2 py-2 text-sm font-medium transition-colors hover:bg-muted/60 group/item"
                >
                  <div className="flex h-8 w-8 items-center justify-center rounded-md bg-muted mr-3">
                    <FontAwesomeIcon
                      icon={faHospitalUser}
                      className="text-primary-500 group-hover/item:text-primary-600 transition-colors"
                    />
                  </div>
                  Acesse como paciente
                </a>
                <a
                  href="/professional"
                  className="flex items-center rounded-md px-2 py-2 text-sm font-medium transition-colors hover:bg-muted/60 group/item"
                >
                  <div className="flex h-8 w-8 items-center justify-center rounded-md bg-muted mr-3">
                    <FontAwesomeIcon
                      icon={faUserMd}
                      className="text-secondary-500 group-hover/item:text-secondary-600 transition-colors"
                    />
                  </div>
                  Acesse como profissional
                </a>
                <Link
                  to="/user"
                  className="flex items-center rounded-md px-2 py-2 text-sm font-medium transition-colors hover:bg-muted/60 group/item"
                >
                  <div className="flex h-8 w-8 items-center justify-center rounded-md bg-muted mr-3">
                    <FontAwesomeIcon
                      icon={faTableColumns}
                      className="text-secondary-500 group-hover/item:text-secondary-600 transition-colors"
                    />
                  </div>
                  Portal Admin
                </Link>
              </div>
            </div>
          </div>

          {/* Animated CTA Button - Only shown on Home and Login pages */}
          {showCTA && (
            <Link
              to="/user/signup"
              className="btn-vortex inline-flex items-center justify-center rounded-md text-xs sm:text-sm leading-tight font-bold transition-all focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring h-auto min-h-8 sm:min-h-9 px-3 sm:px-6 py-1.5 text-white hover:shadow-lg hover:scale-105 text-center"
            >
              <span className="sm:hidden">Começar</span>
              <span className="hidden sm:inline">Começar Agora</span>
            </Link>
          )}
        </div>
      </nav>
    </header>
  );
}
